import axios from 'axios'
import {Message} from 'element-ui'
import store from '@/store'
import {auth} from '@/utils/auth'
import router from '@/router'
import Cookies from "js-cookie";
// 跨域认证信息 header 名
const xsrfHeaderName = 'Access-Token'
axios.defaults.withCredentials = true
axios.defaults.xsrfHeaderName = xsrfHeaderName
axios.defaults.xsrfCookieName = xsrfHeaderName

const service = axios.create({
    timeout: 60000, // request timeout,
    withCredentials: true,
    xsrfCookieName: xsrfHeaderName,
    xsrfHeaderName: xsrfHeaderName,
})

service.interceptors.request.use(
    config => {
        const route = router;
        config.headers['Authorization'] = route.history.current.path.includes('customerEnterprise') ? auth.getKqToken() : auth.getToken()
        config.headers['PhysicalSeal'] = Cookies.get('PhysicalSeal')
        if (config['Content-Type']) {
            config.headers['Content-Type'] = config['Content-Type']
        } else {
            config.headers['Content-Type'] = 'application/json'
        }

        return config
    },
    error => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    response => {
        const res = response.data
        if (res.code !== 1 && !(res instanceof Blob)) {
            // Message({
            //   message: res.message || res.msg || 'Error',
            //   type: 'error',
            //   duration: 5 * 1000
            // })
            if (res.code === 401) {
                auth.removeKqToken()
                if (res.msg.includes('kq')) {
                    Message({
                        message: '登录过期，请重新登录！',
                        type: 'error',
                        duration: 5 * 1000
                    })
                    auth.removeKqToken()
                    location.reload()
                } else {
                    store.dispatch('account/logout').then(() => {
                        location.reload()
                    })
                }
            }
            return response
        } else {
            return response
        }
    },
    error => {
        if (error.message.includes('401')) {
            auth.removeKqToken()
            store.dispatch('account/logout').then(() => {
                location.reload()
            })
        }
        Message({
            message: error || 'Error',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

/**
 * axios请求
 * @param url 请求地址
 * @param method {METHOD} http method
 * @param params 请求参数
 * @returns {Promise<AxiosResponse<T>>}
 */

//跨域代理前缀
// const BASE_URL =
const BASE_URL = process.env.VUE_APP_API_BASE_URL

const request = {
    get: async (url, params, config) => {
        return service.get(BASE_URL + url, {params, ...config})
    },
    post: async (url, params, config) => {
        return service.post(BASE_URL + url, params, config)
    },
    put: async (url, params, config) => {
        return service.put(BASE_URL + url, params, config)
    },
    delete: async (url, params, config) => {
        return service.delete(BASE_URL + url, {params, ...config})
    },
    all(values = []) {
        return Promise.all(values)
    }
}

export {
    request,
}
